import React, { PropsWithChildren } from 'react'

import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import FullWidthCarousel from 'components/Luxkit/Carousel/FullWidthCarousel'

interface Props extends PropsWithChildren {
  variant: 'card' | 'full-width'
}

function CarHireDiscountUpcomingOrderCarouselWrapper(props: Props) {
  const { children, variant = 'full-width' } = props

  if (variant === 'card') {
    return <CardCarousel>
      {children}
    </CardCarousel>
  }

  return <FullWidthCarousel>
    {children}
  </FullWidthCarousel>
}

export default CarHireDiscountUpcomingOrderCarouselWrapper
